import { useIM } from '@wui/im'

import { PSTNGUEST } from '@/shared/utils/constants'
import {
  fromPServedUser,
  isNotPServed,
  isPServedIsUser,
  isPstnGuest,
  numberToUri,
  parseGuidFromPServed,
} from '@/shared/utils/uri'

const extractDialNumber = (to: string): string => {
  if (isNotPServed(to)) {
    return to
  }

  return parseGuidFromPServed(to) || fromPServedUser(to)
}

export const resolveTerminalCallTarget = async (to: string): Promise<string> => {
  if (isPstnGuest(to)) {
    return to
  }

  const number = extractDialNumber(to)

  if (isPServedIsUser(to)) {
    return number
  }

  let isSubscriber = false

  try {
    isSubscriber = await useIM().subscribeOnConferenceUpdates({
      pServed: numberToUri(number),
    })
  } catch (e) {
    console.error(e)
  }

  return isSubscriber ? number : `${PSTNGUEST}-${number}`
}
